import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import DropdownControl from "../InputControls/DropdownControl";
import { useStateValue } from "../../../store/StateProvider";
import { getSellerCreationErrors, getFieldValidationErrors } from "../../../utils/validator";

const InputDropdown = ({ fieldConfig, showErrors }) => {
  const [{ hiddenFields, sellerCreationErrors, formValues }] = useStateValue();
  const sellerCreationFieldError = getSellerCreationErrors(fieldConfig.id, sellerCreationErrors);
  const [errorMessage, setErrorMessage] = useState(sellerCreationFieldError);
  const [firstLoad, setFirstLoad] = useState(true);

  const labelClass = `input_label_plain ${fieldConfig.labelClass}`;

  const setError = error => {
    setErrorMessage(error);
  };

  const executeFieldValidation = () => {
    const error = getFieldValidationErrors(fieldConfig.validators, formValues, fieldConfig.id);
    setError(error);
  };

  useEffect(() => {
    if (showErrors) {
      executeFieldValidation();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showErrors]);

  const isHidden = !!(hiddenFields.includes(fieldConfig.id) || fieldConfig.isHidden);

  return (
    <Form.Group
      className={`mb3 ${fieldConfig.containerClass} ${isHidden ? "hidden" : ""}`}
      id={`container_${fieldConfig.id}`}
      controlId={fieldConfig.name}>
      <Form.Label className={labelClass}>{fieldConfig.label}</Form.Label>
      <Form.Label className="label_description">{fieldConfig.labelDescription}</Form.Label>
      <DropdownControl
        fieldConfig={fieldConfig}
        fieldValidator={executeFieldValidation}
        removeErrorMessage={setError.bind(this, null)}
        hasError={!!errorMessage}
        setFirstLoad={setFirstLoad}
      />
      <Form.Label
        className={`label_error ${!!errorMessage && (!firstLoad || showErrors || sellerCreationFieldError) ? "show" : "hidden"}`}
        id={`label_error_${fieldConfig.id}`}>
        <span id={`label_error_message_${fieldConfig.id}`}>{errorMessage}</span>
      </Form.Label>
    </Form.Group>
  );
};

export default InputDropdown;
